// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__9q7dQ","opacity-transition":"success_opacity-transition__HREQR"};